/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { withNoTranslate } from "i18n/noTranslate";

import type { FormType } from "./AccountAddress";
import type { FC } from "react";
import type { FieldErrors, UseFormRegisterReturn } from "react-hook-form";

export const AccountAddressPhone: FC<{
  register: UseFormRegisterReturn;
  errors: FieldErrors<FormType>;
  defaultValue: string;
}> = ({ register, errors, defaultValue }) => {
  const classes = styles();

  return (
    <div css={classes.formItem}>
      <input
        {...withNoTranslate({ className: errors?.phone ? "error" : "" })}
        type={"text"}
        defaultValue={defaultValue}
        {...register}
      />

      {errors?.phone?.message && (
        <p css={classes.errorMessage}>{errors?.phone?.message}</p>
      )}
    </div>
  );
};

const styles = () => {
  return {
    formItem: css`
      input[type="text"] {
        width: 100%;
        padding: 8px;
        font-size: 16px;
        border: 1px solid #e6e5e6;
      }
      .error {
        border: 1px solid #ff0000 !important;
        background-color: rgba(255, 0, 0, 0.1) !important;
      }
    `,
    errorMessage: css`
      margin-top: 8px;
      color: #ff0000;
      font-size: 12px;
      font-weight: bold;
    `,
  };
};
